import React, { forwardRef } from "react";
import styled from "styled-components";

const Block = forwardRef(({ children, maxHeight }, ref) => {
    return (
        <BlockContainer ref={ref}>
            <BlockBody $maxHeight={maxHeight}>
                {children}
            </BlockBody>
        </BlockContainer>
    );
});

const BlockContainer = styled.div`
    display: flex;
    width: 100%;
    min-width: 277px;
    flex-direction: column;
    margin-top: 15px;
`;

const BlockBody = styled.main`
    border-radius: 10px;
    z-index: 10;
    width: 100%;
    height: auto;
    min-height: ${({ $maxHeight }) => $maxHeight}px;
    display: flex;
    flex-direction: column;
`;


export default Block;